import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import Accordion from 'components/accordion/Accordion';
import Icon from 'components/icon/Icon';

import DatesMoreLinkList from './DatesMoreLinkList';

import { IDatesMore } from 'source/NFR.types';

const themes = defineTheme({
  small: 'dates-more--theme-small',
  medium: 'dates-more--theme-medium'
});
type DatesMoreTheme = ThemeKeys<typeof themes>;

interface IDatesMoreProps extends IDatesMore {
  theme?: DatesMoreTheme;
  showMoreDates?: boolean;
  className?: string;
  refProp?: React.RefObject<HTMLDivElement>;
  style?: React.CSSProperties;
}

const DatesMore: React.FC<IDatesMoreProps> = ({
  accordion,
  title,
  dates,
  theme,
  showMoreDates,
  className,
  refProp,
  style
}) => {
  return (dates && dates.length) || showMoreDates ? (
    <Accordion {...accordion} buttonTextForLabel={title}>
      {({ Button, Collapse, isOpen, toggle }) => (
        <div
          className={cn(themes(theme), className, { 'dates-more__button--is-open': isOpen })}
          ref={refProp}
          style={style}
        >
          <Button className={cn('dates-more__button', { 'dates-more__button--is-open': isOpen })}>
            {title && (
              <>
                <h3 className="dates-more--title">{title}</h3>
                <Icon className={cn('dates-more--icon', { 'dates-more__button--is-open': isOpen })} name="arrow-down" />
              </>
            )}
          </Button>
          {dates && dates.length && (
            <Collapse className="dates-more--collapse">
              <DatesMoreLinkList dates={dates} isOpen={isOpen} toggleAccordion={toggle} />
            </Collapse>
          )}
        </div>
      )}
    </Accordion>
  ) : null;
};

DatesMore.displayName = 'DatesMore';

export default DatesMore;
